import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { getInvoiceStreamNames } from '@/shared/services/InvoiceStreamService';
import { InvoiceStreamQueryKey } from './queryKey';
export const useGetInvoiceStreamNames = (relationId) => {
    const intl = useIntl();
    const { data, isLoading, error, refetch } = useQuery([InvoiceStreamQueryKey.Names, relationId], () => getInvoiceStreamNames(relationId), {
        enabled: !!relationId,
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
    return {
        invoiceStreams: relationId ? data : undefined,
        error,
        isLoading,
        refetch,
    };
};
export default useGetInvoiceStreamNames;
